<template>
  <div class="tab_bar">
    <div
      v-for="(item, index) in tabberList"
      :key="index"
      class="tab_item"
      :class="active === index ? 'active' : ''"
      @click="updateActiveTab(item.path, index)"
    >
      <img :src="active === index ? item.iconActive : item.icon" />
      <span>{{ item.name }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "AppTabBar",
  data() {
    return {
      active: 0,
      tabberList: [
        {
          name: "首页",
          path: "/home",
          icon: require("@/assets/images/shouye.png"),
          iconActive: require("@/assets/images/shouyeED.png"),
        },
        {
          name: "助推订单",
          path: "/boostOrders",
          icon: require("@/assets/images/dingdan.png"),
          iconActive: require("@/assets/images/dingdanED.png"),
        },
        {
          name: "新建助推",
          path: "/newBoost",
          icon: require("@/assets/images/xinjian.png"),
          iconActive: require("@/assets/images/xinjianED.png"),
        },
      ],
    };
  },
  watch: {
    $route(to) {
      this.updateActiveTab(to.path);
    },
  },
  created() {
    this.updateActiveTab(this.$route.path);
  },
  methods: {
    updateActiveTab(path) {
      const routes = ["/home", "/boostOrders", "/newBoost"];
      this.active = routes.indexOf(path);
      const currentPath = this.$route.path;
      if (currentPath !== path) {
        this.$router.push(path);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.tab_bar {
  width: 348px;
  height: 56px;
  border-radius: 36px;
  border: 1px solid #fff;
  position: fixed;
  bottom: 10px;
  left: 3.5%;
  background: #fff;
  display: flex;
  justify-content: space-between;
  padding: 0 28px;
  box-sizing: border-box;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0),
    0px 0px 9px 0px rgba(0, 0, 0, 0.01), 0px 0px 8px 0px rgba(0, 0, 0, 0.05),
    0px 0px 6px 0px rgba(0, 0, 0, 0.09), 0px 0px 3px 0px rgba(0, 0, 0, 0.1);
  .tab_item {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    img {
      width: 14px;
      height: 14px;
      object-fit: cover;
      margin-right: 5px;
    }
  }
  .active {
    color: #2575f2;
  }
}
</style>
